<template>
    <div :class="pageClass">
        <HeaderBar/>
        <div class="header-spacer"></div>
        <div class="component-window">
            <transition name="fade" mode="out-in">
                <component :is="components[currentComponent].name" v-bind="components[currentComponent].props" @emitSwap="advanceComponent($event)" @confirmIntakeSubmit="advanceComponent($event)"></component>
            </transition>
        </div>
    </div>
</template>

<script>
import HeaderBar from './Components/IntakeHeader.vue'
import StepOne from './Components/StepOne.vue'
import UCRs from '../Onboarding/components/UCRInfo.vue'
import Contact from '../Onboarding/components/ContactInfo.vue'
import Confirm from './Components/IntakeConfirm.vue'
import { GetComponentNumber } from '../Onboarding/utils/functions.js'
export default {
    components: {
        HeaderBar,
        StepOne,
        UCRs,
        Contact,
        Confirm
    },
    data() {
        return {
            currentComponent: 0,
            userTriedToAdvanceLocal: false,
        }
    },
    computed: {
        components() {
            return [
                {
                    name: "StepOne",
                },
                {
                    name: "Contact",
                    props: {userTriedToAdvance: this.userTriedToAdvanceLocal, mode: "intake"}
                },
                {
                    name: "UCRs",
                    props: {userTriedToAdvance: this.userTriedToAdvanceLocal, mode: "intake"}
                },
                {
                    name: "Confirm",
                    props: {}
                }
            ]
        },
        pageClass() {
            return {
                "page": true,
                "page-two": this.currentComponent === GetComponentNumber('intake_ucrs') ? true : false,
                "contact": this.currentComponent === GetComponentNumber('intake_contact') ? true : false,
                "confirm": this.currentComponent === GetComponentNumber('intake_confirm') ? true : false,
            }
        },
        store() {
            return this.$store.state;
        }
    },
    methods: {
        advanceComponent(event) {
            const shouldGoForward = event.shouldGoForward;
            this.userTriedToAdvanceLocal = true;
            if(this.currentComponent === GetComponentNumber('intake_contact') && !this.$store.getters.contactPageFilled('intake')) {
                return;
            }
            if (shouldGoForward) {
                this.currentComponent++;
                this.userTriedToAdvanceLocal = false;
            }
        }
    }
}
</script>

<style scoped>

html, body {
    margin: 0;
    padding: 0;
}

.header-spacer {
    height: var(--header-height)
}

.page {
    width: 100vw;
    height: auto;
    min-height: calc(100vh - var(--header-height));
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: var(--color-teal-background);
    overflow-y: auto;
    margin: 0;
    padding: 0;
}

.page-two {
    height: auto;
    min-height: 100vh;
}

.contact {
    height: 100vh;
}

.component-window {
    height: 90%;
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 3em;
  }
</style>